import { inject, Injectable } from '@angular/core';
import { EnvironmentConfig } from 'src/app/configs/environment.config';
import { fixedEnvironment } from 'src/environments/environment.fixed';
import { ApolloClient, ApolloLink } from '@apollo/client';
import { HttpLink } from 'apollo-angular/http';
import { InitDataService } from '@src/app/services/data/init-data.service';
import { LoggingService } from '@src/app/services/logging/logging.service';
import { v4 as uuidv4 } from 'uuid';
import { JgApolloMemoryCache } from '@src/app/services/apollo/jg-apollo-memory-cache';

export const loadApolloConfig = (): ApolloClient.Options => {
  const httpLink = inject(HttpLink);
  const apolloConfig = inject(ApolloServiceConfig);
  const dataService = inject(InitDataService);
  const loggingService = inject(LoggingService);
  const _userIdent = `${uuidv4()}`;

  return {
    link: httpLink.create({
      uri: (operation: ApolloLink.Operation) => apolloConfig.backendUrl + apolloConfig.gqlEntryPoint + '?' + new URLSearchParams({
        _o: operation?.operationName,
        _i: _userIdent,
        _s: dataService.currentScope,
      }).toString(),

      withCredentials: apolloConfig.withCredentials,
    }),
    cache: new JgApolloMemoryCache(loggingService),
    defaultOptions: apolloConfig.defaultOptions,
  };
};

@Injectable({
  providedIn: 'root',
})
export class ApolloServiceConfig {
  public backendUrl: string = 'http://localhost:9000';
  public gqlEntryPoint: string = '/graphql/graphql';
  public withCredentials = true;
  public defaultOptions: ApolloClient.DefaultOptions = {
    watchQuery: {
      errorPolicy: 'all',
    },
  };
}

export function createApolloServiceConfig(env: EnvironmentConfig): ApolloServiceConfig {
  const config = new ApolloServiceConfig();

  if (env) {
    const usePortalBackend = new URL(window.location.href).searchParams.get('usePortal') === 'true';
    if (env.backendUrl) {
      config.backendUrl = env.backendUrl;
    }

    // Switch to portal backend if desired
    if (usePortalBackend && env.portalBackendUrl) {
      config.backendUrl = env.portalBackendUrl;
    }

    if (fixedEnvironment.gqlEntryPoint) {
      config.gqlEntryPoint = fixedEnvironment.gqlEntryPoint;
    }
  }

  return config;
}
